import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Ryaskov.pro</h3>
            <p className="footer-description">
              Комплексная система управления ремонтом квартир для профессионалов
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">Возможности</h4>
            <ul className="footer-links">
              <li><Link to="/">Учет времени</Link></li>
              <li><Link to="/">Контроль этапов</Link></li>
              <li><Link to="/">Управление материалами</Link></li>
              <li><Link to="/">Финансовый контроль</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">Поддержка</h4>
            <ul className="footer-links">
              <li><Link to="/">Документация</Link></li>
              <li><Link to="/">Контакты</Link></li>
              <li><Link to="/">FAQ</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">Начать работу</h4>
            <Link to="/login" className="footer-cta">
              <i className="ri-rocket-line"></i>
              Войти в систему
            </Link>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Ryaskov.pro. Все права защищены.</p>
          <p className="footer-legal-links">
            <Link to="/privacy-policy">Политика обработки персональных данных</Link>
            {' · '}
            <Link to="/terms">Условия использования</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
